<header class="zag-card__header">
  <ng-content select="[card-header]"></ng-content>
</header>

<div class="zag-card__body">
  <ng-content></ng-content>
</div>

<footer class="zag-card__footer">
  <ng-content select="[card-footer]"></ng-content>
</footer>
